import React, { Component } from 'react'

import SimpleSelect from '../SharedComponents/dropdownselection'

import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Grid from '@material-ui/core/Grid'
import Checkbox from '@material-ui/core/Checkbox'

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import config from "../../config/config"
import axios from 'axios'
import {styles} from '../CSS/Styles'
import {extractData} from '../../util/TableUtil'

import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'

class RiskInventory extends Component {
    constructor(props) {
        super(props)
        this.state = {
            value: 0,
            filter: [],
            table: [],
            isFilterByCategory: false,
            isFilterByTier: false,
            isFilterByGroup: false,
            addNew:false,
            newRiskName:''

        }
    }

    //getTasks(){
    //    axios.get(config.task)
    //    .then(res => {
    //        this.setState({
    //
    //        })
    //    })
    //}

    getFilter() {
        let filterData = {
            'Category': ['Strategic', 'Operational', 'Financial', 'Compliance', 'Technology'],
            'Risk Tier': ['Tier 1', 'Tier 2', 'Tier 3']
        }
        this.setState( { filter: filterData } )
        for (let val in filterData) {
            let data = filterData[val]
            for (let filter in data){
                this.setState({ [data[filter]]: true })
            }
        }
    }



    getInitialState() {
    }

    componentDidMount() {
    }

    componentWillMount() {
        // get top header filter data 
        this.getFilter()
        //this.setState(getState())
        //setInterval(() => {
        //    this.setState(getState())
        //}, 4000);
    }

    handleChange = name => event => {
        
        this.setState({ [name]: event.target.checked })
        
    };

    componentWillUpdate() {

    }


    handleTierChange = (event,id) => {
        switch (event.target.value) {
            case 1:
            axios.put(config.risks + "/" + id  ,{tier_level:"Tier1"}).then((res)=>{
                console.log(res)
                this.props.fetchdata()
            })
            break
            case 2:
            axios.put(config.risks + "/" + id ,{tier_level:"Tier2"}).then((res)=>{
                console.log(res)
                this.props.fetchdata()
            })
            break
            case 3:
            axios.put(config.risks + "/" + id ,{tier_level:"Tier3"}).then((res)=>{
                console.log(res)
                this.props.fetchdata()
            })
            break
        }
    }

    handleNewRisk = ()=>{
        this.setState({addNew:true})
    }
    handleNewRiskTextChange = (event) => {
        console.log(event.target.value)
        this.setState({ newRiskName: event.target.value })
    };
    handleAddingNewRisk = ()=>{
        console.log("add new risk")
        this.setState({addNew:false})
        console.log(this.state.newRiskName)
        
        let risknameList = this.props.data.map(a => a.risk_name);
        let riskIDList = risknameList.map(a => parseInt(a.split('.')[0].substring(1), 10))
        let maxID = Math.max(...riskIDList)
        let newRiskID = maxID+1


        let riskTemplate = {
            risk_name: 'R'+ newRiskID +'. '+this.state.newRiskName,
            strategic: "✔",
            operational: null,
            compliance: null,
            financial: null,
            technology: null,
            risk_description: "Risk Description",
            NETS: "✔",
            BCS: "✔",
            BCSIS: null,
            no_appetite: "✔",
            very_low_appetite: null,
            low_appetite: null,
            medium_appetite: null,
            high_appetite: null,
            risk_appetite_statements: "risk appetite statement",
            residual_likelhood: "1 - Very Unlikely",
            residual_impact: "1 - Very Low",
            residual_rating: "Low",
            target_likelhood: "1 - Very Unlikely",
            target_impact: "1 - Very Low",
            target_rating: "Low",
            gross_likelhood: "1 - Very Unlikely",
            gross_impact: "1 - Very Low",
            gross_rating: "Low",
            risk_driver: ["risk driver 1","risk driver 2"],
            risk_consequence: ["risk consequence 1","risk consequence 2"]
            // tier_level, current, update_itme, upload_by is handled at BE.
        }
        axios.post(config.risk + riskTemplate.risk_name, riskTemplate, riskTemplate.risk_name)
            .then(res=>{
                window.location.reload()
        })
    }
    render() {
        const { classes } = this.props;
        const filters = ()=>{
            let filterJSX = []
            for (var filter in this.state.filter) {
                filterJSX.push(
                    <div style={{ textAlign: 'left', paddingLeft: '10px'}}>
                        <typography style={{ display: 'inline-block', minWidth: '120px'}}> {filter} : </typography>
                        {this.state.filter[filter].map((data)=>{
                            return (
                                <div style={{display:'inline-block', textAlign:'left', minWidth:'120px'}}>
                                    <Checkbox
                                        checked={this.state[data]}
                                        onChange={this.handleChange(data)}
                                        value={data}
                                        color='primary'
                                    />
                                    <typography> {data} </typography>
                                </div>
                            )
                        })}
                    </div>
                )
            }
            return filterJSX
        }
        const filterheader = filters();

        const header = ['id', 'No', 'Category', 'Risk', 'Risk Description', 'Tier']
        const dataBaseHeader = ['id', 'risk_name', 'category', 'risk_name', 'risk_description', 'tier_level']
        const data = extractData(this.props.data, header, dataBaseHeader)

        const table = (
            <Table>
                <TableHead>
                    <TableRow>
                        {header.map((headeritem)=>{
                            if (headeritem == 'id') {
                                return null
                            }
                            return (
                                <TableCell style={{textAlign:headeritem == 'Tier' ? 'center':null}} 
                                    className = {classes.table_header}>
                                    {headeritem}
                                </TableCell>
                            )
                        })}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.sort((a, b)=> a.No > b.No ? 1 : -1)
                        .map((item)=> {
                            if (!this.state[item.Category]) {
                                return (null)
                            }
    
                            if (!this.state['Tier ' + (item.Tier)[4]]) {
                                return (null)
                            }
    
                            //if (this.state.isFilterByGroup) {
                            //    if (!this.state[item.Group]) {
                            //        return (null)
                            //    }
                            //}
    
                            return (
                                <TableRow>
                                    {header.map((headeritem)=> {
                                        if (headeritem == 'id') {
                                            return null
                                        }
                                        if (headeritem == 'Risk Description') {
                                            let data = item[headeritem].split('\n')
                                            return (
                                                <TableCell>
                                                    {data.map((dataitem)=>{
                                                        return(
                                                            <p className={classes.table_cell} style={{margin:'2px'}}>
                                                                {dataitem=='Notes'? <br/>:null}
                                                                {dataitem}
                                                            </p>
                                                        )
                                                    })}
                                                </TableCell>
                                            )
                                        } else if (headeritem == 'Tier') {
                                            return (
                                                <TableCell>
                                                    <SimpleSelect 
                                                        fetchdata={()=>{this.props.fetchdata()}} 
                                                        id={item.id} 
                                                        handleSelect = {this.handleTierChange} 
                                                        Tier={item.Tier}
                                                    />
                                                </TableCell>
                                            )
                                        } else {
                                            return (
                                                <TableCell>
                                                    <div className={classes.table_cell}> {item[headeritem]} </div>
                                                </TableCell>
                                            )
                                        }
                                    })}
                                </TableRow>
                            )
                        })}
                </TableBody>
            </Table>
        )
        return (
            <div flexGrow={1}>
                {filterheader}
                <Button
                    variant='outlined'
                    color='primary'
                    style={{float:'left'}}
                    onClick= {this.handleNewRisk}
                >
                    NEW RISK
                </Button>
                {this.state.addNew == false ? null:
                    <div>
                        <TextField
                            id = "NewRiskName"
                            className={classes.FormTextField}
                            onChange = {(event) => this.handleNewRiskTextChange(event)}
                            value = {this.state.RiskDescription}
                            placeholder = "New Risk Name"
                            style={{paddingLeft:'15px', paddingRight:'10px', float:'left'}}
                        />
                        <Button
                            variant='outlined'
                            color='primary'
                            style={{float:'left'}}
                            onClick= {this.handleAddingNewRisk}
                        >
                            ADD
                        </Button>
                    </div>
                }
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <Card className={classes.cardL0}>
                            <CardContent >
                                {table}
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </div>
        )
    }
}
export default withStyles(styles)(RiskInventory);


// WEBPACK FOOTER //
// ./src/components/Risks/RiskInventory.js